import { EpocusRole } from "elephant-web/gql";

export type ProgramRoleOption = {
  role: EpocusRole;
  label: string;
};

export const PROGRAM_ROLE_OPTIONS: readonly ProgramRoleOption[] = [
  { role: EpocusRole.Performer, label: "Performer" },
  { role: EpocusRole.Reviewer, label: "Reviewer" },
  { role: EpocusRole.QaAdmin, label: "QA Admin" },
  { role: EpocusRole.ProgramAdmin, label: "Program Admin" },
];

export const roleLabelForRole = (role?: EpocusRole | null): string =>
  PROGRAM_ROLE_OPTIONS.find((option) => option.role === role)?.label ?? "—";
